// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/OpenSans-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Poppins-Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}
@font-face {
  font-family: 'Poppins-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
@font-face {
  font-family: 'Poppins-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}
@font-face {
  font-family: 'Poppins-SemiBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
@font-face {
  font-family: 'Poppins-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}
@font-face {
  font-family: 'OpenSans-ExtraBoldItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/global/fonts.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,+DAAgE;AAClE;AACA;EACE,8BAA8B;EAC9B,+DAAkE;AACpE;AACA;EACE,6BAA6B;EAC7B,+DAAiE;AACnE;AACA;EACE,+BAA+B;EAC/B,+DAAmE;AACrE;AACA;EACE,2BAA2B;EAC3B,+DAA+D;AACjE;AACA;EACE,uCAAuC;EACvC,+DAA2E;AAC7E","sourcesContent":["@font-face {\n  font-family: 'Poppins-Light';\n  src: url('../assets/fonts/Poppins-Light.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Poppins-Regular';\n  src: url('../assets/fonts/Poppins-Regular.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Poppins-Medium';\n  src: url('../assets/fonts/Poppins-Medium.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Poppins-SemiBold';\n  src: url('../assets/fonts/Poppins-SemiBold.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Poppins-Bold';\n  src: url('../assets/fonts/Poppins-Bold.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'OpenSans-ExtraBoldItalic';\n  src: url('../assets/fonts/OpenSans-ExtraBoldItalic.ttf') format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
